import React, { useCallback, useState } from 'react'
import { Media } from './MediaDetailOverlay'
import { formatBytes } from './results/MediaGrid'
import styled from 'styled-components'

export const MediaVersionsTable: React.FC<{ apiHost: string; mediaId: string; files: Media['files'] }> = ({
  mediaId,
  files,
  apiHost
}) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>Name</th>
          <th>File type</th>
          <th>Size</th>
          <th style={{ width: 114 }} />
        </tr>
      </thead>

      <tbody>
        {files.map((file) => (
          <tr key={file.id}>
            <td>{file.name}</td>
            <td>{file.extension}</td>
            <td>
              {file.height > 0 && file.width > 0 && `${file.height} x ${file.width} px | `}
              {formatBytes(file.fileSize)}
            </td>

            <td>
              <DownloadFileButton apiHost={apiHost} mediaId={mediaId} {...file}>
                Download
              </DownloadFileButton>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

const Table = styled.table`
  width: 100%;
  * > th {
    padding: 0 16px 8px 0px;

    text-align: left;
    font-family: Roboto;
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
    color: #939393;

    border-bottom: 1px solid #f5f5f5;
  }

  * > td {
    padding: 16px 0px;
    font-family: Roboto;
    font-size: 14px;
    line-height: 22px;
    color: #303030;

    border-bottom: 1px solid #f5f5f5;
  }
`

const DownloadFileButton: React.FC<{ apiHost: string; mediaId: string } & Media['files'][number]> = ({
  apiHost,
  mediaId,
  id,
  fileName,
  children
}) => {
  const [status, setStatus] = useState<'initial' | 'loading' | 'ok' | 'error'>('initial')
  const onClick = useCallback(async () => {
    setStatus('loading')
    try {
      window.location.href = await (await fetch(`${apiHost}/Asset/${mediaId}/download/${id}`)).text()
      setStatus('ok')
    } catch (error) {
      setStatus('error')
    }
  }, [apiHost, mediaId, id])

  return (
    <Button disabled={status === 'error' || status === 'loading'} onClick={onClick}>
      {status === 'error' ? 'Error' : status === 'loading' ? '...' : 'Download'}
    </Button>
  )
}

const Button = styled.button`
  outline: none;
  border: none;
  cursor: pointer;

  text-align: center;
  font-family: Roboto;
  font-weight: 500;
  font-size: 12px;
  line-height: 30px;
  text-transform: uppercase;

  color: #ffffff;
  background: #56a0d3;
  border-radius: 100px;

  padding: 4px 24px;
  min-width: 114px;

  &:hover {
    background: #4683ae;
  }
`
